// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.
const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_cognito_identity_pool_id": "eu-west-1:a6b4cce3-58f5-4464-a5bb-20e7a65be5ed",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_JvvdPhJKW",
    "aws_user_pools_web_client_id": "2hf5kg55pfce5uc7vnuq07p1le",
    "oauth": {}
};


export default awsmobile;
